import { DriversImportResponse } from '../../models/drivers-import-response';
import { DriversInvalidRecord } from '../../models/drivers-invalid-record';

export function catalogDriversImportResponse(
  validationResult: string,
  importResult: string,
  vehicleId: string,
  data: Record<string, unknown>,
  importResponse: DriversImportResponse
) {
  switch (validationResult) {
    case 'DuplicateDriverId':
    case 'DuplicateDriverIdInPartner':
    case 'EmptyDriverId':
    case 'OverCharLimitDriverId':
      importResponse.invalid.push(
        new DriversInvalidRecord(vehicleId, 'invalid-id', data)
      );
      break;
    case 'DuplicateDriverName':
    case 'EmptyDriverName':
    case 'OverCharLimitDriverName':
      importResponse.invalid.push(
        new DriversInvalidRecord(vehicleId, 'invalid-name', data)
      );
      break;
    case 'OK':
      importResponse.imported += 1;
      if (importResult === 'Inserted') {
        importResponse.importInserted += 1;
      } else {
        importResponse.importUpdated += 1;
      }
      break;
    default:
      importResponse.unrecoverable += 1;
      break;
  }
}
